import { paserParams } from "../../until";
import authuClient from "../authuClient";
import axiosClient, { ResponseSuccess } from "../axiosClient";

export interface ILogin {
  status: boolean
  message: string
  data: IUser
  token: string
  // dataMenu: IPermission[]
}
export interface IPermission {
  id: number
  menuId: number
  groupPermissionId: number
  access: boolean
  add: boolean
  edit: boolean
  delete: boolean
  upload: boolean
  download: boolean
  share: boolean
  approve: boolean
  menuUrl:string
}
export interface dataPermissionCustomer {
  id: number
  username: boolean
  gender: boolean
  phoneHome: boolean
  phoneCompany: boolean
  hobby: boolean
  profession: boolean
  birthday: boolean
  email: boolean
  CCCD: boolean
  province: boolean
  district: boolean
  address: boolean
  taxCode: boolean
  businessName: boolean
  foundingDate: boolean
  businessRelationship: boolean
  actions: number
  statusMarital: boolean
  groupCustomer: boolean
  image: boolean
  description: boolean
  affiliated: boolean
  sourceCustomer: boolean
  careStaff: boolean
  businessFieldId: boolean
  unit: boolean
  code: boolean
}
export interface IUser {
  id: number
  unit: number
  username: string
  image: string
  groupPermission: number | null
  role: boolean
  unitTemp: number
  sessionTimeout?:number
}
export interface IuserInfor {
  status: boolean
  message: string
  data: IUser
  dataMenu: IPermission[]
  dataPermissionCustomer: dataPermissionCustomer[]
}

export const login = async (username: string, password: string) => {
  const path = "auth/login"
  const params = {
    username,
    password,
  }
  const result: ILogin = await authuClient.post(path,
    paserParams(params, undefined)
  );
  return result;
};

// thông tin người dùng
// export const permissionUser = async (unitId: number, groupPermissionId?: number) => {
//   const path = "auth/infoPermissionUser"
//   const params = {
//     unitId,
//     groupPermissionId,
//   }
//   const result: IuserInfor = await axiosClient.get(path,
//     { params }
//   );
//   return result;
// };
// thông tin người dùng
export const changePermissionUnit = async (adminId: number, unitId: number) => {
  const path = "groupPermission/conversionUnit"
  const params = {
    adminId,
    unitId,
  }
  const result: IuserInfor = await axiosClient.get(path,
    { params }
  );
  return result;
};
